import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { range } from '/@/utils';
import styles from './styles.module.css';

@autobind
export default class Dots extends Component {
    static propTypes = {
        max: PropTypes.oneOf([4, 5, 9]).isRequired,
        value: PropTypes.number,
        reference: PropTypes.bool,
        showValues: PropTypes.bool,
        reverse: PropTypes.bool,
    };

    render() {
        const { max, value, reference, showValues, reverse } = this.props;
        const order = reverse ? range(max).reverse() : range(max);

        return (
            <div className={classNames(styles.root, { [styles.reference]: reference })}>
                {order.map((index) => {
                    const number = index + 1;
                    const selected = number === value;
                    return (
                        <div
                            key={number}
                            className={classNames(styles.dot, styles[`dot-${max}`], {
                                [styles.selected]: selected,
                            })}
                        >
                            {showValues && (selected || reference) && number}
                        </div>
                    );
                })}
            </div>
        );
    }
}
